import React from 'react';
import AnimatedBadge from './AnimatedBadge';
import { User, AlertTriangle } from 'lucide-react';

const AuthScreen = ({ onGoogleLogin, onGuestLogin }) => {
  return (
    <div className="container">
      <div className="page-badge"><AnimatedBadge size={66} /></div>
      <div className="card">
        <h1>Visa Document Assistant</h1>
        <p className="subtitle">Welcome! Choose a sign-in option</p>
        
        <div className="auth-options">
          <button 
            onClick={onGoogleLogin}
            className="btn btn-primary auth-btn"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" className="google-icon">
              <path fill="currentColor" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="currentColor" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="currentColor" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="currentColor" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            Sign in with Google
          </button>
          
          <div className="divider">
            <span>or</span>
          </div>
          
          <div className="guest-section">
            <div className="guest-warning">
              <AlertTriangle size={20} className="warning-icon" />
              <div className="warning-text">
                <h3>Guest Mode</h3>
                <p>Your data will be stored only in this browser. If you clear the browser or switch devices, you will lose access to your documents.</p>
              </div>
            </div>
            
            <button 
              onClick={onGuestLogin}
              className="btn btn-secondary auth-btn"
            >
              <User size={20} />
              Continue as Guest
            </button>
          </div>
        </div>
        
        <div className="auth-benefits">
          <h3>Benefits of Google sign-in:</h3>
          <ul>
            <li>✓ Access from any device</li>
            <li>✓ Automatic email notifications</li>
            <li>✓ Secure document storage</li>
            <li>✓ History of all applications</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AuthScreen;
